import { css, breakpoints } from '../../../styles/theme';
import styled from 'styled-components';
import { OrderPanelStyled } from '../OrderPanelStyled';
import { rem } from 'polished';

export const OrderPanelStyledAC = styled(OrderPanelStyled)`
    background: ${({ theme }) => theme.colors.grey6};

    .desktopContactSection {
        display: flex;
        justify-content: center;
        flex-direction: column;
      
        .phoneLink {
            color: ${({ theme }) => theme.colors.grey5};

            &:hover,
            &:focus-visible {
                text-decoration: underline;
            }
        }
    }

    .priceSection {
        .catalogPrice {
            span,
            .catalogPriceLabel,
            .catalogPriceAmount {
                font-size: ${({ theme }) => theme.fontSizes.h6};
            }
        }
        .price {
            .cashPrice,
            .priceConjunction,
            .monthlyPrice > .price {
                font-size: ${({ theme }) => theme.fontSizes.h4};
                color: ${({ theme }) => theme.colors.grey5};
            }

            .showPriceExcludedVAT {
                .currencyLabel__suffix--OTR {
                    font-size: ${rem('12px')};
                }
            }

            .vertical {
                svg {
                    height: ${rem('16px')};
                    width: ${rem('16px')};
                    g {
                        circle {
                            fill: ${({ theme }) => theme.colors.grey5};
                            stroke: none;
                        }

                        line {
                            stroke: ${({ theme }) => theme.colors.white};
                            stroke-width: ${rem('3px')};
                        }
                    }
                }
            }
        }

        .showPriceExcludedVAT-container {
            .cashPrice {
                font-size: ${rem('16px')};
            }

            .currencyLabel__suffix--OTR {
                font-size: ${rem('12px')};
            }
        }
    }

    .benefitSection {
        &.desktop {
            border-left: 1px solid ${({ theme }) => theme.colors.grey26};
        }

        svg {
            circle {
                fill: ${({ theme }) => theme.colors.grey5};
                stroke: none;
            }

            line {
                stroke: ${({ theme }) => theme.colors.white};
                stroke-width: ${rem('3px')};
            }
        }
    }

    .buttonSection {
        border-left: 1px solid ${({ theme }) => theme.colors.grey26};
    }
`;
